import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useShopifyStore = create(
  persist(
    (set, get) => ({
      // UI State
      activeTab: 'connections',
      selectedConnection: null,
      
      // Connections
      connections: [],
      loadingConnections: false,
      
      // Sync State
      syncStatus: {},
      syncLogs: [],
      loadingLogs: false,
      
      // Settings
      settings: {
        autoSync: true,
        syncInterval: 300,
        syncDirection: 'bidirectional',
        notifications: true
      },
      
      // Actions
      setActiveTab: (tab) => set({ activeTab: tab }),
      
      setSelectedConnection: (connection) => set({ selectedConnection: connection }),
      
      setConnections: (connections) => set({ connections }),
      
      setLoadingConnections: (loading) => set({ loadingConnections: loading }),
      
      addConnection: (connection) => set((state) => ({
        connections: [...state.connections, connection]
      })),
      
      updateConnection: (id, updates) => set((state) => ({
        connections: state.connections.map(conn =>
          conn.id === id ? { ...conn, ...updates } : conn
        )
      })),
      
      removeConnection: (id) => set((state) => ({
        connections: state.connections.filter(conn => conn.id !== id),
        selectedConnection: state.selectedConnection?.id === id ? null : state.selectedConnection
      })),
      
      setSyncStatus: (connectionId, status) => set((state) => ({
        syncStatus: {
          ...state.syncStatus,
          [connectionId]: status
        }
      })),
      
      setSyncLogs: (logs) => set({ syncLogs: logs }),
      
      setLoadingLogs: (loading) => set({ loadingLogs: loading }),
      
      updateSettings: (updates) => set((state) => ({
        settings: { ...state.settings, ...updates }
      })),
      
      reset: () => set({
        activeTab: 'connections',
        selectedConnection: null,
        connections: [],
        syncStatus: {},
        syncLogs: []
      })
    }),
    {
      name: 'shopify-plugin-storage',
      partialize: (state) => ({
        settings: state.settings
      })
    }
  )
);

export default useShopifyStore;
